import styled from 'styled-components';
import Text from './Text';

const BoldText = styled(Text)`
  font-weight: 600;
  font-size: 0.8vw;
`;

export default BoldText;
